import React from "react";
import { StyleRulesCallback, Theme, withStyles, WithStyles } from "@material-ui/core/styles";
import { FormattedMessage, FormattedPlural } from "react-intl";

import { ITotal } from "../types";
import { Placeholder } from "./Placeholder";

const styles: StyleRulesCallback = (theme: Theme) => ({
  baseText: {
    ...theme.typography.body1,
    fontWeight: theme.typography.fontWeightMedium
  },
  secondaryText: {
    color: theme.palette.text.secondary
  }
});

interface IProps extends ITotal, WithStyles<typeof styles> {}

const BaseTotalResults: React.FC<IProps> = ({ classes, loading, total }) => {
  if (loading) {
    return <Placeholder />;
  }

  if (!Boolean(total)) {
    return null;
  }

  const values = {
    totalResults: <span className={classes.baseText}>{total}</span>
  };
  return (
    <div className={`${classes.baseText} ${classes.secondaryText}`}>
      <FormattedPlural
        one={<FormattedMessage id="results.totalResults.one" values={values} />}
        other={<FormattedMessage id="results.totalResults.other" values={values} />}
        value={total!}
      />
    </div>
  );
};

export const TotalResults = withStyles(styles)(BaseTotalResults);
